import React from "react";
import UserIconImage from "../../../../../../../assets/images/researcher_app/sessions/user_icon.png";

function UserIcon() {
    return (
        <img src={UserIconImage} alt="User Icon" className="user-icon" />
    )
}

export default UserIcon